import { useState, useEffect } from 'react';

import withLocalization from '~/hoc/withLocalization';
import UserProfileLogo from '../UserProfileLogo';

const MemberSearchList = ({ members, selectedId, onSelect, title, t }) => {
    const [filterName, setFilterName] = useState('');
    const [filteredMembers, setFilteredMembers] = useState(members || []);

    useEffect(() => {
        setFilteredMembers(members || []);
    }, [members]);

    useEffect(() => {
        if (!filterName) setFilteredMembers(members || []);
    }, [filterName]);

    const handleSearch = () => {
        if (!filterName) {
            setFilteredMembers(members || []);
            return;
        }
        setFilteredMembers((members || []).filter(ele => ele?.name?.toLowerCase().includes(filterName.toLowerCase())));
    };

    return (
        <div className="border border-radius-10" style={{ maxHeight: '100%', overflow: 'auto' }}>
            <div className="d-flex align-items-center justify-content-between m-2 mb-2">
                <h5 className='fw-600 mb-0'>{title || t('Members')}</h5>
                <div className="conversation-search" style={{ maxWidth: '65%' }}>
                    <input
                        type="text"
                        className="conversation-search-input"
                        placeholder={t('Search')}
                        onChange={(e) => setFilterName(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.code === 'Enter')
                                handleSearch();
                        }}
                        value={filterName}
                    />
                    <i className="fa fa-search conversation-search-icon" onClick={() => handleSearch()} />
                </div>
            </div>
            {filteredMembers.length > 0 ?
                <div className={"overflow-auto"} style={{ height: '680px' }} >
                    {filteredMembers.map((ele, index) => (
                        <div key={ele?.id ?? index}
                            className={`d-flex align-items-center cursor-pointer border-top-1 ${selectedId === ele?.id ? 'custom-active-bg' : ''}`}
                            onClick={() => onSelect(ele)}>
                            <UserProfileLogo image_id={ele?.image ? ele.image : false} width='35px' height="35px" className={'m-2'} />
                            <span className='ml-10 d-flex align-items-center'>{ele.name}</span>
                        </div>
                    ))}
                </div>
                :
                <div className='d-flex justify-content-center fw-600'>{t('No data found')}</div>
            }
        </div>
    );
};

export default withLocalization(MemberSearchList);
